export const getEndOfMonth = (dateString, groupBy = "month") => {
  try {
    if (groupBy === "year" && dateString?.match(/^\d{4}$/)) {
      return `${dateString}-12-31`;
    }

    let date;
    if (dateString?.match(/^\d{4}-\d{2}$/)) {
      date = new Date(`${dateString}-01T00:00:00`);
    } else if (dateString) {
      date = new Date(`${dateString}T00:00:00`);
    } else {
      date = new Date();
    }

    const nextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1);
    const finalDate = new Date(nextMonth.getTime() - 1);
    const year = finalDate.getFullYear();
    const month = String(finalDate.getMonth() + 1).padStart(2, "0");
    const day = String(finalDate.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  } catch {
    return new Date().toISOString().split("T")[0];
  }
};

export const formatNumber = (value) => {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    value === "-"
  ) {
    return "-";
  }

  if (typeof value === "string" && value.includes("%")) {
    return value;
  }

  const numericValue =
    typeof value === "number"
      ? value
      : parseFloat(String(value).replace(/,/g, ""));

  if (Number.isNaN(numericValue)) {
    return String(value);
  }

  const formatted = Math.abs(numericValue).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return numericValue < 0 ? `(${formatted})` : formatted;
};

export const isNegative = (value) => {
  if (value === null || value === undefined || value === "") {
    return false;
  }

  const numericValue =
    typeof value === "number"
      ? value
      : parseFloat(String(value).replace(/[(),]/g, "").replace(/,/g, ""));

  return !Number.isNaN(numericValue) && numericValue < 0;
};
